<template>
  <div
    v-if="availableWindowLocalStorage()"
    id="Save"
    style="width: 100%"
    :class="`tour_map_step2 dropdown  ${
      core.tableWidthSize == 'xs' ? 'splitText' : ''
    } `"
  >
    <template v-if="core.enableSaveToLocalStorage">
      <template>
        <v-btn
          small
          color="primary"
          dark
          @click="core.notsaveDialog = true"
          :title="$t('common.title_save')"
        >
          <v-icon x-small color="green">lens</v-icon>
          <span>{{ $t("common.autoSave") }}</span>
        </v-btn>
      </template>
    </template>

    <template v-else>
      <template>
        <v-btn small color="secondary" dark @click="core.saveDialog = true">
          <v-icon x-small color="red">lens</v-icon>
          <span>{{ $t("common.noAutoSave") }}</span>
        </v-btn>
      </template>
    </template>
  </div>
</template>

<script src="<%= BASE_URL %>lib/jquery-3.5.1.min.js"></script>
<script>
export default {
  watch: {
    [`core.enableSaveToLocalStorage`]() {
      if (this.core.enableSaveToLocalStorage) {
        this.core.saveDialog = false;
      } else {
        this.core.notsaveDialog = false;
      }
    },
  },
  data() {
    return {};
  },
  props: ["core"],
  methods: {
    availableWindowLocalStorage() {
      let result = this.core.checkLocalforageSupport() ? true : false;
      // console.log(result)
      return result;
    },
  },
};
</script>

<style scoped lang="sass">
.splitText
  .v-btn
    padding: 18px 12px
    span
      white-space: normal !important
      width: 140px !important
</style>